<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- droping file -->
      <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>

      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet"
            type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
            type="text/css"/>

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css"
            rel="stylesheet">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>

    </head>

    <body @contextmenu.prevent data-sidebar="dark">

    <!-- Begin page -->
    <div id="layout-wrapper">

      <NavigationBar/>

      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div id="content" class="content-minimize">

        <div class="page-content">
          <div class="container-fluid">

            <!-- start page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">UNPAID BILLS</h4>

                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a>
                      </li>
                      <li class="breadcrumb-item active">unpaid bills</li>
                    </ol>
                  </div>

                </div>
              </div>
            </div>

            <ToolBar/>
            <!-- end page title -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">

                    <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100"
                         role="toolbar">
                      <h4 class="card-title text-capitalize mb-0 ">
                        All Invoices
                      </h4>

                      <div class="d-flex">
                        <a v-if="getRight('SBP CREATE BILL')" @click="gotTo('new-bill')"
                           class="btn btn-primary dropdown-toggle option-selector me-3 text-capitalize"
                           type="button">
                          <i class="mdi mdi-plus-circle-outline  font-size-16"></i> <span
                            class="pl-1 d-md-inline">Create A Bill</span>
                        </a>

                      </div>


                    </div>
                  </div>

                  <div>
                    <!-- Filters Section -->
                    <div class="card-header bg-white pt-0 pr-0 p-0 border-bottom">
                      <div class="p-3">
                        <!-- First Row of Filters -->
                        <div class="row g-2 mb-2">
                          <div class="col-md-3 col-sm-6">
                            <select class="form-select font-13px" v-model="subCounty" @change="getBillsPaginate(subCounty.subCountyName)">
                              <option selected="" value="">All Sub Counties</option>
                              <option :key="index" :value="item" v-for="(item, index) in subCounties">
                                {{ item.subCountyName }}
                              </option>
                            </select>
                          </div>

                          <div class="col-md-3 col-sm-6">
                            <select class="form-select font-13px" v-model="ward" @change="getZones(ward.wardID, ward.wardName)">
                              <option selected="" value="">All Wards</option>
                              <option :key="index" :value="item" v-for="(item, index) in wards">
                                {{ item.wardName }}
                              </option>
                            </select>
                          </div>

                          <div class="col-md-3 col-sm-6">
                            <select class="form-select font-13px" v-model="zone" @change="getUsers(zone)">
                              <option selected="" value="">All Zones</option>
                              <option v-for="(item, index) in zones" :key="`${index}`">{{item.zone}}</option>
                            </select>
                          </div>

                          <div class="col-md-3 col-sm-6">
                            <select class="form-select font-13px" v-model="idNo" @change="getBillsPaginate(idNo)">
                              <option selected="">All Attendants</option>
                              <option v-for="(item, index) in users" :key="`${index}`" :value="item.idNo">{{item.names}}</option>
                            </select>
                          </div>
                        </div>

                        <!-- Second Row of Filters -->
                        <div class="row g-2 align-items-center">
                          <div class="col-md-2 col-sm-6">
                            <select class="form-select font-13px" v-model="billStatus" @change="getBillsPaginate()">
                              <option value="UNPAID">Unpaid Bills</option>
                              <option value="PAID">Paid Bills</option>
                              <option value="ALL">All Bills</option>
                            </select>
                          </div>

                          <div class="col-md-3 col-sm-6">
                            <label class="form-label mb-0 font-13px">From:</label>
                            <input v-model="dateFrom" class="form-control font-13px" placeholder="Start date" type="date">
                          </div>

                          <div class="col-md-3 col-sm-6">
                            <label class="form-label mb-0 font-13px">To:</label>
                            <input v-model="dateTo" class="form-control font-13px" placeholder="End date" type="date">
                          </div>

                          <div class="col-md-2 col-sm-6">
                            <select class="form-select font-13px" v-model="downloadScope">
                              <option value="current">Current Page</option>
                              <option value="all">All Records</option>
                            </select>
                          </div>

                          <div class="col-md-2 col-sm-6">
                            <button v-if="getRight('DOWNLOAD SBP INVOICES')" @click="initiateDownload()" type="button" class="btn btn-primary w-100 font-13px">
                              <i class="bx bxs-download font-size-16"></i> <span class="pl-1">Download</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="card-body">
                    <div class="table-responsive">

                      <table class="table align-middle table-hover contacts-table table-striped"
                             id="datatable-buttons">
                        <thead class="table-light">
                        <tr class="table-dark">
                          <th class="text-nowrap" scope="col" style="width: 50px;">NO.</th>
                          <th class="text-nowrap" scope="col" style="min-width: 150px;">Bill No</th>
                          <th class="text-nowrap" scope="col" style="min-width: 250px;">Business Details</th>
                          <th class="text-nowrap" scope="col" style="min-width: 150px;">Location</th>
                          <th class="text-nowrap text-end" scope="col" style="width: 120px;">Amount</th>
                          <th class="text-nowrap" scope="col" style="width: 100px;">Status</th>
                          <th class="text-nowrap" scope="col" style="width: 120px;">Attendant</th>
                          <th class="text-nowrap" scope="col" style="width: 100px;"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr :key="index" :value="item" v-for="(item, index) in billDetails">
                          <td class="text-nowrap">{{index+1}}</td>
                          <td class="text-nowrap">
                            <div class="fw-semibold">{{item.billNo}}</div>
                            <small class="text-muted">{{item.dateCreated}}</small>
                          </td>
                          <td>
                            <div class="fw-semibold">{{item.customerName || item.description}}</div>
                            <small class="text-muted d-block">{{item.incomeTypeDescription}}</small>
                            <small class="text-muted">{{item.feeDescription}}</small>
                          </td>
                          <td>
                            <div>{{item.subCountyName}}</div>
                            <small class="text-muted">{{item.wardName}}</small>
                            <small v-if="item.zone" class="d-block text-muted">{{item.zone}}</small>
                          </td>
                          <td class="text-end">
                            <div class="fw-bold text-primary">{{formatPrice(item.billBalance)}}</div>
                            <small class="text-muted d-block">Billed: {{formatPrice(item.detailAmount)}}</small>
                            <small v-if="item.receiptAmount > 0" class="text-success d-block">Paid: {{formatPrice(item.receiptAmount)}}</small>
                          </td>
                          <td>
                                                        <span class="badge badge-soft-success text-uppercase"
                                                              v-if="item.status==='PAID'">PAID</span>
                            <span class="badge badge-soft-danger text-uppercase"
                                  v-if="item.status !=='PAID'">UNPAID</span>
                          </td>
                          <td class="text-nowrap">
                            <small>{{item.names}}</small>
                          </td>
                          <td>
                            <button @click="getBill(item.billNo)"
                                    class="btn btn-primary btn-sm waves-effect waves-light text-nowrap"
                                    data-target="#billDetail" data-toggle="modal"
                                    type="button">
                              <i class="mdi mdi-eye"></i>
                            </button>
                          </td>
                        </tr>
                        </tbody>
                        <tfoot class="table-dark">
                        <tr>
                          <th colspan="4" class="text-start">
                            {{billDetails.length}} Bills
                          </th>
                          <td class="text-end">
                            <div class="fw-bold">Balance: {{totalBillBalance}}</div>
                            <small class="d-block">Billed: {{totalDetailAmount}}</small>
                            <small class="d-block">Paid: {{totalReceiptAmount}}</small>
                          </td>
                          <th colspan="3"></th>
                        </tr>

                        </tfoot>
                      </table>

                      <div v-if="loading" class="card-body px-5 d-flex flex-column justify-items-center align-items-center text-center d-flex justify-content-center">
                        <div class="p-5 py-0 pt-3">
                          <div class="p-5">
                            <div class="spinner-border text-info m-1" role="status">
                              <span class="sr-only text-uppercase">Loading...</span>
                            </div>
                          </div>
                        </div>
                        <h4 class="text-uppercase">Loading Data</h4>
                        <div class="col-sm-12 col-md-8 col-lg-5">
                          <p>We are fetching the data for you. It will be ready soon. Please wait and have fun. Thank you for your interest.</p>

                        </div>
                      </div>
                      <div v-if="billDetails.length<1 & loading===false" class="card-body d-sm-none d-md-block px-5 d-flex flex-column justify-items-center align-items-center text-center">
                        <div class="p-5 py-0 pt-3">
                          <img :src="'./assets/images/no-results.png'" class="img mb-4"  alt="No search results"/>
                        </div>
                        <h4>No Results To Show</h4>
                        <p>Sorry, we could not find any results that match your search or filter criteria. Please try using different keywords or filters.</p>
                      </div>

                    </div>
                  </div>
                  <div class="card-footer bg-white">
                    <nav aria-label="Page navigation example "
                         class="d-flex align-items-center justify-content-between">

                      <div class="d-flex align-items-center">
                                            <span class="pr-3 pb-0 mb-0 font-13px">
                                                <span>Rows Per Page</span>
                                            </span>
                        <select class="form-select w-auto font-13px " v-model="pageSize">
                          <option value="10">10 Rows</option>
                          <option value="25">25 Rows</option>
                          <option value="50">50 Rows</option>
                          <option value="100">100 Rows</option>
                          <option value="150">150 Rows</option>
                          <option value="200">200 Rows</option>
                          <option value="5000">5000 Rows</option>
                          <option value="10000">10000 Rows</option>
                        </select>
                      </div>

                      <ul class="pagination">
                        <!-- add a class of disabled and an attribute of disabled when the current page is the first page -->
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <a class="page-link" tabindex="-1" @click="prevPage" :disabled="currentPage === 1">Previous</a>
                        </li>
                        <!-- replace the v-for directive with the pagination function call -->
                        <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page" class="page-item" :class="{ active: currentPage === page }">
                          <!-- check if the page is an ellipsis and display it as plain text -->
                          <span v-if="page === '...'" class="page-link">{{ page }}</span>
                          <!-- otherwise, display it as a clickable link -->
                          <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                        </li>
                        <!-- add a class of disabled and an attribute of disabled when the current page is the last page -->
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <a class="page-link"  @click="nextPage" :disabled="currentPage === totalPages">Next</a>
                        </li>
                      </ul>


                    </nav>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>

            <!-- end row -->
          </div>
          <!-- container-fluid -->
        </div>
        <!-- End Page-content -->

        <!-- Bill Details Modal - Modern Design -->
        <div aria-hidden="true" class="modal fade" id="billDetail" role="dialog" tabindex="-1">
          <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
              <!-- Modal Header with County Branding -->
              <div class="modal-header border-0 bg-primary text-white">
                <div class="d-flex align-items-center">
                  <i class="bx bx-receipt font-size-24 me-2"></i>
                  <div>
                    <h5 class="modal-title mb-0 text-white">Invoice Details</h5>
                    <small class="opacity-75">{{billNo}}</small>
                  </div>
                </div>
                <button aria-label="Close" class="btn-close btn-close-white" data-dismiss="modal" type="button"></button>
              </div>

              <div class="modal-body p-4">
                <!-- Bill Status Badge -->
                <div class="text-center mb-4">
                                    <span v-if="billDetail.status === 'PAID'" class="badge bg-success font-size-16 px-4 py-2">
                                        <i class="mdi mdi-check-circle me-1"></i> PAID
                                    </span>
                  <span v-else class="badge bg-danger font-size-16 px-4 py-2">
                                        <i class="mdi mdi-alert-circle me-1"></i> UNPAID
                                    </span>
                </div>

                <!-- Business & Customer Info Cards -->
                <div class="row mb-4">
                  <!-- Business Info -->
                  <div class="col-md-6">
                    <div class="card border shadow-sm h-100">
                      <div class="card-body">
                        <h6 class="card-title text-muted text-uppercase mb-3">
                          <i class="bx bx-building me-2"></i>Business Information
                        </h6>
                        <div class="mb-2">
                          <strong class="text-primary">{{customer.names || billDetail.customerName || billDetail.description}}</strong>
                        </div>
                        <div class="mb-2">
                          <small class="text-muted">Phone:</small>
                          <span class="ms-2">{{maskPhoneNumber(billDetail.customerPhoneNumber || customer.phoneNumber)}}</span>
                        </div>
                        <div v-if="billDetail.customers">
                          <small class="text-muted">Reference:</small>
                          <span class="ms-2">{{billDetail.customers}}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Location & Officer Info -->
                  <div class="col-md-6">
                    <div class="card border shadow-sm h-100">
                      <div class="card-body">
                        <h6 class="card-title text-muted text-uppercase mb-3">
                          <i class="bx bx-map me-2"></i>Location & Officer
                        </h6>
                        <div class="mb-2">
                          <small class="text-muted">Sub County:</small>
                          <span class="ms-2 fw-semibold">{{billDetail.subCountyName}}</span>
                        </div>
                        <div class="mb-2">
                          <small class="text-muted">Ward:</small>
                          <span class="ms-2">{{billDetail.wardName}}</span>
                        </div>
                        <div v-if="billDetail.zone" class="mb-2">
                          <small class="text-muted">Zone:</small>
                          <span class="ms-2">{{billDetail.zone}}</span>
                        </div>
                        <div class="mt-3 pt-2 border-top">
                          <small class="text-muted">Issued By:</small>
                          <span class="ms-2 fw-semibold">{{billDetail.names}}</span>
                        </div>
                        <div>
                          <small class="text-muted">Date:</small>
                          <span class="ms-2">{{formatDateTime(billDetail.dateCreated)}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Bill Items Table -->
                <div class="card border shadow-sm mb-4">
                  <div class="card-header bg-light">
                    <h6 class="mb-0 text-uppercase">
                      <i class="bx bx-list-ul me-2"></i>Bill Items
                    </h6>
                  </div>
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0">
                        <thead class="table-light">
                        <tr>
                          <th style="width: 50px;" class="text-center">#</th>
                          <th style="min-width: 200px;">Description</th>
                          <th style="width: 150px;">Category</th>
                          <th style="width: 100px;" class="text-center">Qty</th>
                          <th style="width: 150px;" class="text-end">Amount</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in billInfo" :key="index">
                          <td class="text-center">{{index + 1}}</td>
                          <td>
                            <div class="fw-semibold">{{item.feeDescription}}</div>
                            <small v-if="item.customer" class="text-muted">{{maskPhoneNumber(item.customer)}}</small>
                          </td>
                          <td>
                            <span class="badge bg-soft-primary text-primary">{{item.incomeTypePrefix}}</span>
                          </td>
                          <td class="text-center">
                            <span class="badge bg-soft-info text-info">{{item.quantity || 1}}</span>
                          </td>
                          <td class="text-end fw-bold text-primary">KES {{numberFormat(item.billTotal)}}</td>
                        </tr>
                        </tbody>
                        <tfoot class="table-light">
                        <tr>
                          <td colspan="4" class="text-end fw-bold text-uppercase">Total Amount:</td>
                          <td class="text-end">
                            <h5 class="mb-0 text-primary fw-bold">KES {{numberFormat(billDetail.detailAmount)}}</h5>
                          </td>
                        </tr>
                        <tr v-if="billDetail.receiptAmount > 0">
                          <td colspan="4" class="text-end text-success">Amount Paid:</td>
                          <td class="text-end text-success fw-semibold">KES {{numberFormat(billDetail.receiptAmount)}}</td>
                        </tr>
                        <tr>
                          <td colspan="4" class="text-end fw-bold">
                                                            <span :class="billDetail.billBalance > 0 ? 'text-danger' : 'text-success'">
                                                                Balance Due:
                                                            </span>
                          </td>
                          <td class="text-end">
                            <h5 class="mb-0 fw-bold" :class="billDetail.billBalance > 0 ? 'text-danger' : 'text-success'">
                              KES {{numberFormat(billDetail.billBalance)}}
                            </h5>
                          </td>
                        </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>

                <!-- Payment Information (if paid) -->
                <div v-if="billDetail.status === 'PAID'" class="card border-success shadow-sm mb-4">
                  <div class="card-header bg-soft-success">
                    <h6 class="mb-0 text-success">
                      <i class="mdi mdi-cash-check me-2"></i>Payment Information
                    </h6>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-4">
                        <small class="text-muted">Transaction Code:</small>
                        <div class="fw-semibold">{{billDetail.transactionCode || 'N/A'}}</div>
                      </div>
                      <div class="col-md-4">
                        <small class="text-muted">Paid By:</small>
                        <div class="fw-semibold">{{billDetail.paidBy || 'N/A'}}</div>
                      </div>
                      <div class="col-md-4">
                        <small class="text-muted">Payment Method:</small>
                        <div class="fw-semibold">{{billDetail.source || 'N/A'}}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Payment Instructions (if unpaid) -->
                <div v-if="billDetail.status !== 'PAID'" class="card border-warning shadow-sm">
                  <div class="card-header bg-soft-warning">
                    <h6 class="mb-0 text-warning">
                      <i class="mdi mdi-information me-2"></i>Payment Instructions
                    </h6>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <h6 class="fw-semibold">M-PESA Paybill</h6>
                        <ol class="ps-3 mb-0">
                          <li>Go to M-PESA Menu</li>
                          <li>Select Lipa na M-PESA</li>
                          <li>Select Pay Bill</li>
                          <li>Enter Business No: <strong class="text-primary">{{payBill.shortCode}}</strong></li>
                          <li>Enter Account No: <strong class="text-primary">{{billNo}}</strong></li>
                          <li>Enter Amount: <strong class="text-danger">{{billDetail.billBalance}}</strong></li>
                          <li>Enter PIN and Confirm</li>
                        </ol>
                      </div>
                      <div class="col-md-6">
                        <h6 class="fw-semibold">Bank Details</h6>
                        <div class="mb-2">
                          <small class="text-muted">Bank Name:</small>
                          <div class="fw-semibold">{{bank.bank}}</div>
                        </div>
                        <div class="mb-2">
                          <small class="text-muted">Account Number:</small>
                          <div class="fw-semibold">{{bank.payBill}}</div>
                        </div>
                        <div class="mb-2">
                          <small class="text-muted">Reference:</small>
                          <div class="fw-semibold">{{billNo}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Modal Footer with Actions -->
              <div class="modal-footer bg-light border-0">
                <button @click="printBill()" class="btn btn-primary waves-effect waves-light" type="button">
                  <i class="mdi mdi-printer me-2"></i> Print Invoice
                </button>
                <button class="btn btn-soft-secondary waves-effect" data-dismiss="modal" type="button">
                  <i class="mdi mdi-close me-2"></i> Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- end of bill details modal -->

        <!-- Download Progress Modal -->
        <div aria-hidden="true" class="modal fade" id="downloadProgressModal" role="dialog" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header border-0">
                <h5 class="modal-title">Downloading Records</h5>
              </div>
              <div class="modal-body">
                <div class="text-center mb-4">
                  <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

                <div class="mb-3">
                  <div class="d-flex justify-content-between mb-2">
                    <span class="text-muted">Progress</span>
                    <span class="fw-bold">{{ downloadProgress.percentage }}%</span>
                  </div>
                  <div class="progress" style="height: 25px;">
                    <div class="progress-bar progress-bar-striped progress-bar-animated"
                         role="progressbar"
                         :style="{width: downloadProgress.percentage + '%'}"
                         :aria-valuenow="downloadProgress.percentage"
                         aria-valuemin="0"
                         aria-valuemax="100">
                      {{ downloadProgress.percentage }}%
                    </div>
                  </div>
                </div>

                <div class="row text-center">
                  <div class="col-4">
                    <div class="border rounded p-2">
                      <h6 class="text-muted mb-0 font-13px">Downloaded</h6>
                      <h4 class="mb-0 text-primary">{{ downloadProgress.downloaded }}</h4>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="border rounded p-2">
                      <h6 class="text-muted mb-0 font-13px">Total</h6>
                      <h4 class="mb-0">{{ downloadProgress.total }}</h4>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="border rounded p-2">
                      <h6 class="text-muted mb-0 font-13px">Remaining</h6>
                      <h4 class="mb-0 text-info">{{ downloadProgress.remaining }}</h4>
                    </div>
                  </div>
                </div>

                <div class="mt-3 text-center">
                  <p class="mb-1"><i class="mdi mdi-clock-outline me-1"></i> Estimated Time: <strong>{{ downloadProgress.estimatedTime }}</strong></p>
                  <p class="text-muted font-13px mb-0">{{ downloadProgress.message }}</p>
                </div>

                <div v-if="downloadProgress.error" class="alert alert-danger mt-3 mb-0">
                  <i class="mdi mdi-alert-circle-outline me-2"></i>{{ downloadProgress.error }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Download Progress Modal -->

        <footer class="footer ">
          <div class="container-fluid ">
            <div class="row ">
              <div class="col-sm-6 ">
                <!--                                <script>-->
                <!--                                    document.write(new Date().getFullYear())-->
                <!--                                </script> © RevenueSure-->
              </div>
              <div class="col-sm-6 ">
                <div class="text-sm-end d-sm-block ">
                  Developed by County
                </div>
              </div>
            </div>
          </div>
        </footer>

      </div>
      <!-- end main content-->

    </div>
    <!-- END layout-wrapper -->

    </body>

  </div>
</template>

<script>
/* eslint-disable */
import {authUrl, biller, execute, executeDownload, getRight, trade} from "@/api";
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import ToolBar from "@/components/sbp/ToolBar";
import moment from "moment";

export default {
  name: "SbpUnPaidBills",
  components: {ToolBar, NavigationBar},
  data() {
    return {
      billStatus: 'UNPAID',
      downloadScope: 'current',
      download:'Download',
      search:'',
      loading: false,
      // set the initial current page as 1
      currentPage: 1,
      // set the total number of pages as 10 (you can change this according to your data source)
      totalPages: 0,
      // set the number of items per page as 5 (you can change this according to your preference)
      pageSize: 10,
      summary: {
        count: 0,
        total: 0
      },
      downloadProgress: {
        percentage: 0,
        downloaded: 0,
        total: 0,
        remaining: 0,
        estimatedTime: '0s',
        message: 'Preparing download...',
        error: null
      },


      totalAmount: null,
      selectedItem: null,
      valueItem: "",
      itemList: [{
        id: null,
        value: null
      }],
      filter: '',
      dateFrom: '',
      dateTo: '',
      message: '',
      alert: {
        success: false,
        info: false,
        failed: false
      },
      billDetails: [
        {
          receiptAmount: "0",
        }

      ],
      billInfo: [],
      receiptInfos: [],
      billDetail: {
        id: null,
        billNo: null,
        incomeTypeID:null,
        incomeTypeDescription:null,
        costCenterNo: null,
        accountNo: null,
        feeID: null,
        detailAmount: null,
        receiptAmount: null,
        billBalance: null,
        wardID:null,
        subCountyID: null,
        status: null,
        dateCreated: null,
      },
      billInfoTotal: 0,
      billNo: '',
      bank: {
        id: null,
        bankID: null,
        bank: '',
        payBill: '',
        format: '',
        bankType: '',
        accountNo: null,
        company: ''
      },
      payBill: {
        id: null,
        stream: '',
        shortCode: ''
      },
      customer: {
        id: null,
        names: '',
        phoneNumber: '',
        email: '',
        createdBy: '',
        dateCreated: ''
      },

      subCounties:[{
        subCountyID: "",
        subCountyName: ""
      }],
      wards:[{
        wardID: "",
        wardName: ""
      }],
      subCounty:{
        subCountyID: "",
        subCountyName: ""
      },
      ward:{
        wardID: "",
        wardName: ""
      },
      zones: [],
      zone:'',
      users: [{
        id: null,
        names: null,
        gender: null,
        email: null,
        phoneNumber:null,
        idNo: null,
        password: null,
        category:null,
        dateCreated:null,
        zone:null,
        subCountyID:null,
        subCountyName:null,
        wardID:null,
        wardName: null,
        lat:null,
        lng: null,
        address: null,
        lastSeen: null,
        status: null,
        des: null,
        target: null,
        permission: null,
        dailyTargets: null,
        monthlyTargets: null,
        financialYearTargets: null,
        createdBy: null,
        deviceId: null,
        logTime: null,
        login: null,
      }],
      user: {
        id: null,
        names:null,
        gender: null,
        email:null,
        phoneNumber: null,
        idNo: null,
        password: null,
        category: null,
        dateCreated: null,
        zone: null,
        subCountyID: null,
        subCountyName: null,
        wardID: null,
        wardName: null,
        lat: null,
        lng:null,
        address: null,
        lastSeen: null,
        status: null,
        des: null,
        target:null,
        permission:null,
        dailyTargets: null,
        monthlyTargets: null,
        financialYearTargets: null,
        createdBy: null,
        deviceId: null,
        logTime: null,
        login:null,
      },
      tradeCategories: [{
        incomeTypeId: null,
        incomeTypeDescription: null,
        incomeTypePrefix: null,
        fundDescription: null,
        status: null,
        departmentID: null,
        zoneCategoryID: null,
        zoneCategory: null
      }],
      tradeSubCategories: [
        {
          feeId: null,
          feeDescription: null,
          unitOfMeasure: null,
          unitFeeAmount: null,
          accountNo: null,
          incomeTypeId: null,
          feeType: null,
          accountDesc: null,
          costCenterNo: null,
          zone: null,
          typeDescription: null,
          prorated: null,
          duration: null
        }
      ],
    }

  },
  watch: {


    getRight(type){
      return getRight(type)
    },
    //pagination code
    // define a watcher for the pageSize property
    pageSize(newPageSize) {
      this.getBillsPaginate()
      // get the total number of items from your data source (you can change this according to your logic)
      const totalItems = this.summary.count;
      // calculate the new total pages by dividing the total items by the new page size and rounding up
      const newTotalPages = Math.ceil(totalItems / newPageSize);
      // update the totalPages data property with the new value
      this.totalPages = newTotalPages;
      // reset the current page to 1
      this.currentPage = 1;

    },
    search(){
      const keyword = this.search;
      this.getBillsPaginate(keyword)
    },

    subCounty: function () {
      this.subCountyID =  this.subCounty.subCountyID
      this.subCountyName =  this.subCounty.subCountyName
      this.getWards()
    } ,
    ward: function () {
      this.wardID = this.ward.wardID
      this.wardName = this.ward.wardName
    },

  },
  computed: {
    //pagination code
    // calculate the start index of the items for the current page
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    // calculate the end index of the items for the current page
    endIndex() {
      return this.currentPage * this.pageSize;
    },

    totalReceiptAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.receiptAmount), 0));
    }, totalBillBalance() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.billBalance), 0));
    },
    totalDetailAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.detailAmount), 0));
    }

  },
  mounted() {
    this.getTradeCategory()
    this.dateFrom = moment().startOf('month').format('YYYY-MM-DD')
    this.dateTo = moment().format('YYYY-MM-DD')

    if (sessionStorage.getItem("keyword") === "") {
      this.getBillsPaginate()
    } else {
      this.search = sessionStorage.getItem("keyword")
      this.getBillsPaginate()
    }


    this.$watch('selectedItem', function (newValue) {
      this.getBillsPaginate(newValue)
    })

    this.$watch('dateFrom', function (newValue) {
      if (this.dateFrom === '' || this.dateTo === '') {

      } else {
        this.getBillsPaginate()
      }

    })
    this.$watch('dateTo', function (newValue) {
      if (this.dateFrom === '' || this.dateTo === '') {

      } else {
        this.getBillsPaginate()
      }
    })

    this.getSubCounties()

    this.menuAccess()
  },
  methods: {

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') {
        return input;
      }

      const digits = input.replace(/\D/g, '');

      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }

      return input;
    },

    menuAccess(){

      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Invoices");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then((res) => {
          })
          .catch((e) => {
          });

    },

    getRight(type){
      return getRight(type)
    },
    //pagination code
    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);
      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      if (start > 1) {
        pages.unshift("...");
      }
      if (end < totalPages) {
        pages.push("...");
      }
      return pages;
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getBillsPaginate()
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getBillsPaginate()
      }
    },
    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getBillsPaginate()
      }
    },

    //number format
    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num)
    },
    formatPrice(value) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    },
    formatDateTime(dateString) {
      if (!dateString) return '';
      return moment(dateString).format('DD MMM YYYY, hh:mm A');
    },
    gotTo(route) {
      router.push(route)
    },


    getTradeCategory() {
      this.loading = true
      this.message = null
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      data.append("incomeTypePrefix", "SBP");
      execute(data, biller)
          .then((res) => {
            this.loading = false
            if (res.data.success) {
              this.tradeCategories = res.data.data.incomeTypes
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },
    getTradeSubCategory(event) {
      this.loading = true
      const json = JSON.parse(event.target.value)
      this.search = json.incomeTypeDescription

      this.getBillsPaginate()
      this.message = null
      this.tradeSubCategories.splice(0)
      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", json.incomeTypeId);
      execute(data, biller)
          .then((res) => {
            this.loading = false
            if (res.data.success) {
              this.tradeSubCategories = res.data.data.feesAndCharges
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },
    selectedTradeSubCategory(event) {
      const data = JSON.parse(event.target.value)
      this.search = data.feeDescription
    },

    getBillsPaginate() {
      this.billDetails.splice(0)
      this.loading = true
      const data = new FormData();
      data.append("function", "getBillsPaginate");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("status","UNPAID")
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("keyword", this.search)
      data.append("status", this.billStatus === 'ALL' ? '' : this.billStatus);
      data.append("incomeTypePrefix", "SBP")
      data.append("subCountyID", this.subCounty.subCountyID)
      data.append("wardID", this.ward.wardID)
      data.append("zone", this.zone)
      data.append("idNo", this.user.idNo)
      execute(data, biller)
          .then((res) => {
            this.loading = false
            this.summary.count = 0
            this.summary.total = 0

            this.totalAmount = null
            if (res.data.success) {
              this.billDetails = res.data.data.billDetails.filter(bill => bill.idNo !== "22337462");

              this.summary.count = this.billDetails.length;
              this.summary.total = this.billDetails.reduce((sum, bill) => sum + Number(bill.receiptAmount || 0), 0);

              this.totalPages = Math.ceil(this.summary.count / this.pageSize);

              this.totalAmount = this.billDetails.reduce((acc, cur) => {
                let receiptAmount = Number(cur.receiptAmount);
                return acc + receiptAmount;
              }, 0);

            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    // Initiate Download Process
    initiateDownload() {
      if (this.downloadScope === 'current') {
        this.downloadCurrentPage();
      } else {
        this.downloadAllRecords();
      }
    },

    // Download Current Page (No API call needed)
    downloadCurrentPage() {
      if (!this.billDetails || this.billDetails.length === 0) {
        alert("No data available to download");
        return;
      }

      try {
        const csvData = this.generateSmartCSV(this.billDetails);
        this.downloadCSVFile(csvData, 'invoices_current_page.csv');
      } catch (error) {
        console.error("Error downloading current page:", error);
        alert("Error downloading: " + error.message);
      }
    },

    // Download All Records with Batch Processing
    async downloadAllRecords() {
      // Show progress modal
      const modal = new bootstrap.Modal(document.getElementById('downloadProgressModal'));
      modal.show();

      // Reset progress
      this.downloadProgress = {
        percentage: 0,
        downloaded: 0,
        total: this.summary.count,
        remaining: this.summary.count,
        estimatedTime: 'Calculating...',
        message: 'Starting download...',
        error: null
      };

      const batchSize = 100; // Fetch 100 records per batch
      const totalRecords = this.summary.count;
      const totalBatches = Math.ceil(totalRecords / batchSize);
      let allRecords = [];
      let startTime = Date.now();

      try {
        for (let batch = 0; batch < totalBatches; batch++) {
          const currentPage = batch + 1;

          // Update progress message
          this.downloadProgress.message = `Fetching batch ${batch + 1} of ${totalBatches}...`;

          // Fetch batch data
          const batchData = await this.fetchBillsBatch(currentPage, batchSize);

          if (batchData && batchData.length > 0) {
            // Filter out excluded records
            const filteredData = batchData.filter(bill => bill.idNo !== "22337462");
            allRecords = allRecords.concat(filteredData);
          }

          // Update progress
          this.downloadProgress.downloaded = allRecords.length;
          this.downloadProgress.remaining = totalRecords - allRecords.length;
          this.downloadProgress.percentage = Math.round((allRecords.length / totalRecords) * 100);

          // Calculate estimated time
          const elapsedTime = (Date.now() - startTime) / 1000; // in seconds
          const recordsPerSecond = allRecords.length / elapsedTime;
          const remainingSeconds = (totalRecords - allRecords.length) / recordsPerSecond;
          this.downloadProgress.estimatedTime = this.formatTime(remainingSeconds);

          // Small delay to prevent overwhelming the server
          await this.delay(100);
        }

        // Generate and download CSV
        this.downloadProgress.message = 'Generating CSV file...';
        const csvData = this.generateSmartCSV(allRecords);

        this.downloadProgress.message = 'Download complete!';
        this.downloadProgress.percentage = 100;

        // Download file
        this.downloadCSVFile(csvData, `invoices_all_${allRecords.length}_records.csv`);

        // Track download
        this.trackDownload();

        // Close modal after 2 seconds
        setTimeout(() => {
          modal.hide();
        }, 2000);

      } catch (error) {
        console.error("Error during batch download:", error);
        this.downloadProgress.error = error.message;
        this.downloadProgress.message = 'Download failed!';
      }
    },

    // Fetch Bills Batch (API Call)
    async fetchBillsBatch(page, rowsPerPage) {
      return new Promise((resolve, reject) => {
        const data = new FormData();
        data.append("function", "getBillsPaginate");
        data.append("page", page);
        data.append("rows_per_page", rowsPerPage);
        data.append("status", "UNPAID");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("keyword", this.search);
        data.append("status", this.billStatus === 'ALL' ? '' : this.billStatus);
        data.append("incomeTypePrefix", "SBP");
        data.append("subCountyID", this.subCounty.subCountyID || '');
        data.append("wardID", this.ward.wardID || '');
        data.append("zone", this.zone || '');
        data.append("idNo", this.user.idNo || '');

        execute(data, biller)
            .then((res) => {
              if (res.data.success) {
                resolve(res.data.data.billDetails);
              } else {
                reject(new Error(res.data.message));
              }
            })
            .catch((e) => {
              reject(e);
            });
      });
    },

    // Generate Smart CSV with AI-like Analysis
    generateSmartCSV(records) {
      if (!records || records.length === 0) {
        throw new Error("No records to export");
      }

      let csv = '';

      // Add Header with Smart Metadata
      csv += '=== INVOICE REPORT ===\n';
      csv += `Generated On: ${moment().format('YYYY-MM-DD HH:mm:ss')}\n`;
      csv += `Generated By: ${sessionStorage.getItem("sessionNames") || 'System'}\n`;
      csv += `Date Range: ${this.dateFrom} to ${this.dateTo}\n`;
      csv += `Total Records: ${records.length}\n`;
      csv += `\n`;

      // Calculate Smart Statistics
      const stats = this.calculateSmartStatistics(records);

      csv += '=== INTELLIGENT ANALYSIS ===\n';
      csv += `Total Billed Amount: KES ${this.numberFormat(stats.totalBilled)}\n`;
      csv += `Total Amount Paid: KES ${this.numberFormat(stats.totalPaid)}\n`;
      csv += `Total Outstanding Balance: KES ${this.numberFormat(stats.totalBalance)}\n`;
      csv += `Average Bill Amount: KES ${this.numberFormat(stats.averageBill)}\n`;
      csv += `Highest Bill: KES ${this.numberFormat(stats.highestBill)} (${stats.highestBillNo})\n`;
      csv += `Lowest Bill: KES ${this.numberFormat(stats.lowestBill)} (${stats.lowestBillNo})\n`;
      csv += `Payment Rate: ${stats.paymentRate}%\n`;
      csv += `\n`;

      // Top Sub Counties
      csv += '=== TOP 5 SUB COUNTIES BY REVENUE ===\n';
      stats.topSubCounties.forEach((item, index) => {
        csv += `${index + 1}. ${item.name}: KES ${this.numberFormat(item.amount)} (${item.count} bills)\n`;
      });
      csv += `\n`;

      // Top Income Types
      csv += '=== TOP 5 INCOME TYPES ===\n';
      stats.topIncomeTypes.forEach((item, index) => {
        csv += `${index + 1}. ${item.name}: KES ${this.numberFormat(item.amount)} (${item.count} bills)\n`;
      });
      csv += `\n`;

      // Attendant Performance
      csv += '=== TOP 10 ATTENDANTS BY BILLS GENERATED ===\n';
      stats.topAttendants.forEach((item, index) => {
        csv += `${index + 1}. ${item.name}: ${item.count} bills, KES ${this.numberFormat(item.amount)}\n`;
      });
      csv += `\n\n`;

      // Add Column Headers
      csv += '=== DETAILED RECORDS ===\n';
      const headers = [
        'Bill No',
        'Business Name',
        'Customer Info',
        'Sub County',
        'Ward',
        'Zone',
        'Income Type',
        'Fee Description',
        'Billed Amount',
        'Amount Paid',
        'Balance',
        'Status',
        'Attendant',
        'Phone Number',
        'Date Created'
      ];
      csv += headers.join(',') + '\n';

      // Add Records
      records.forEach(bill => {
        const row = [
          this.escapeCSV(bill.billNo),
          this.escapeCSV(bill.customerName || bill.description),
          this.escapeCSV(bill.customers),
          this.escapeCSV(bill.subCountyName),
          this.escapeCSV(bill.wardName),
          this.escapeCSV(bill.zone),
          this.escapeCSV(bill.incomeTypeDescription),
          this.escapeCSV(bill.feeDescription),
          bill.detailAmount || '0',
          bill.receiptAmount || '0',
          bill.billBalance || '0',
          bill.status || '',
          this.escapeCSV(bill.names),
          bill.customerPhoneNumber || '',
          bill.dateCreated || ''
        ];
        csv += row.join(',') + '\n';
      });

      return csv;
    },

    // Calculate Smart Statistics
    calculateSmartStatistics(records) {
      const totalBilled = records.reduce((sum, bill) => sum + Number(bill.detailAmount || 0), 0);
      const totalPaid = records.reduce((sum, bill) => sum + Number(bill.receiptAmount || 0), 0);
      const totalBalance = records.reduce((sum, bill) => sum + Number(bill.billBalance || 0), 0);
      const averageBill = totalBilled / records.length;

      // Find highest and lowest bills
      let highestBill = 0, lowestBill = Infinity;
      let highestBillNo = '', lowestBillNo = '';

      records.forEach(bill => {
        const amount = Number(bill.detailAmount || 0);
        if (amount > highestBill) {
          highestBill = amount;
          highestBillNo = bill.billNo;
        }
        if (amount < lowestBill && amount > 0) {
          lowestBill = amount;
          lowestBillNo = bill.billNo;
        }
      });

      // Calculate payment rate
      const paymentRate = totalBilled > 0 ? ((totalPaid / totalBilled) * 100).toFixed(2) : 0;

      // Top Sub Counties
      const subCountyMap = {};
      records.forEach(bill => {
        const name = bill.subCountyName || 'Unknown';
        if (!subCountyMap[name]) {
          subCountyMap[name] = { name, amount: 0, count: 0 };
        }
        subCountyMap[name].amount += Number(bill.detailAmount || 0);
        subCountyMap[name].count += 1;
      });
      const topSubCounties = Object.values(subCountyMap)
          .sort((a, b) => b.amount - a.amount)
          .slice(0, 5);

      // Top Income Types
      const incomeTypeMap = {};
      records.forEach(bill => {
        const name = bill.incomeTypeDescription || 'Unknown';
        if (!incomeTypeMap[name]) {
          incomeTypeMap[name] = { name, amount: 0, count: 0 };
        }
        incomeTypeMap[name].amount += Number(bill.detailAmount || 0);
        incomeTypeMap[name].count += 1;
      });
      const topIncomeTypes = Object.values(incomeTypeMap)
          .sort((a, b) => b.amount - a.amount)
          .slice(0, 5);

      // Top Attendants
      const attendantMap = {};
      records.forEach(bill => {
        const name = bill.names || 'Unknown';
        if (!attendantMap[name]) {
          attendantMap[name] = { name, amount: 0, count: 0 };
        }
        attendantMap[name].amount += Number(bill.detailAmount || 0);
        attendantMap[name].count += 1;
      });
      const topAttendants = Object.values(attendantMap)
          .sort((a, b) => b.count - a.count)
          .slice(0, 10);

      return {
        totalBilled,
        totalPaid,
        totalBalance,
        averageBill,
        highestBill,
        highestBillNo,
        lowestBill,
        lowestBillNo,
        paymentRate,
        topSubCounties,
        topIncomeTypes,
        topAttendants
      };
    },

    // Escape CSV special characters
    escapeCSV(value) {
      if (value === null || value === undefined) return '';
      const stringValue = String(value);
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }
      return stringValue;
    },

    // Download CSV File
    downloadCSVFile(csvContent, filename) {
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // Helper: Delay function
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    // Helper: Format time
    formatTime(seconds) {
      if (isNaN(seconds) || seconds < 0) return '0s';

      if (seconds < 60) {
        return `${Math.round(seconds)}s`;
      } else if (seconds < 3600) {
        const minutes = Math.floor(seconds / 60);
        const secs = Math.round(seconds % 60);
        return `${minutes}m ${secs}s`;
      } else {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        return `${hours}h ${minutes}m`;
      }
    },


    getBill(billNo) {
      this.billNo = billNo
      const data = new FormData();
      data.append("function", "getBill");
      data.append("billNo", billNo);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.billInfo = res.data.data.billInfo
              this.billDetail = res.data.data.billDetails
              this.bank = res.data.data.bank || this.bank
              this.payBill = res.data.data.payBill || this.payBill
              this.customer = res.data.data.customer || this.customer
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },
    printBill() {
      localStorage['params'] = JSON.stringify({
        billNo: this.billDetail.billNo
      })
      const routeData = this.$router.resolve({name: 'bill'});
      window.open(routeData.href, '_blank');
    },


    getSubCounties(){
      const data = new FormData();
      data.append("function", "getSubCounty");
      execute(data,biller)
          .then((res) =>{
            if (res.data.success) {
              this.subCounties =res.data.data.subCounties
            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },
    getWards(){
      this.wards =[]
      this.ward = ''
      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", this.subCounty.subCountyID);
      execute(data,biller)
          .then((res) =>{
            if (res.data.success) {
              this.wards =res.data.data.wards
            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },
    getZones(wardID,wardName){

      wardName = wardName === undefined ? '' : wardName;
      this.getBillsPaginate(wardName)

      this.zones.splice(0)
      const data = new FormData();
      data.append("function", "getZones");
      data.append("wardID", wardID);
      execute(data,authUrl)
          .then((res) =>{
            if (res.data.success) {
              this.zones = res.data.data.zones
            }else{
              this.alert.success = false
              this.alert.failed = true
              this.alert.info = false
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
            this.alert.success = false
            this.alert.failed = true
            this.alert.info = false
          });
    },
    getUsers(zone) {
      zone = zone === undefined ? '' : zone;
      this.getBillsPaginate(zone)
      this.users.splice(0)
      const data = new FormData();
      data.append("function", "getUsers")
      data.append("search", zone)
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {

              this.users = res.data.data.users
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },


    formatExcelDate(dateString) {
      if (!dateString) return '';
      return moment(dateString).format('YYYY-MM-DD HH:mm:ss');
    },

    calculateTotalDetailAmount() {
      return this.billDetails.reduce((sum, bill) => sum + Number(bill.detailAmount || 0), 0);
    },

    calculateTotalReceiptAmount() {
      return this.billDetails.reduce((sum, bill) => sum + Number(bill.receiptAmount || 0), 0);
    },

    calculateTotalBillBalance() {
      return this.billDetails.reduce((sum, bill) => sum + Number(bill.billBalance || 0), 0);
    },

    trackDownload() {
      const data = new FormData();
      data.append("function", "trackDownload");
      data.append("reportType", "invoices");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller)
          .catch((e) => {
            console.error("Error tracking download:", e);
          });
    }
  }
}
</script>

<style scoped>
/* Optional: Add custom styles if needed */
.table td, .table th {
  padding: 0.75rem;
  vertical-align: middle;
}

.font-13px {
  font-size: 13px;
}

/* Bill Modal Styles */
.modal-xl {
  max-width: 1200px;
}

.bg-soft-success {
  background-color: rgba(52, 195, 143, 0.18);
}

.bg-soft-warning {
  background-color: rgba(241, 180, 76, 0.18);
}

.bg-soft-primary {
  background-color: rgba(85, 110, 230, 0.18);
}

.bg-soft-info {
  background-color: rgba(80, 165, 241, 0.18);
}

.card {
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1) !important;
}

.badge {
  font-weight: 500;
  padding: 0.35rem 0.65rem;
}

.table-hover tbody tr:hover {
  background-color: rgba(85, 110, 230, 0.05);
}

/* Smooth animations */
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}

.btn {
  border-radius: 0.3rem;
  padding: 0.5rem 1.2rem;
}

/* Print-friendly styles */
@media print {
  .modal-header,
  .modal-footer {
    display: none;
  }
}
</style>